
import { ChannelkartNetworkGet, ChannelkartNetworkPut } from "./networkService";

export async function updateMetaData(requestBody: any) {
      const response = await ChannelkartNetworkPut(`/metadata/clientconfig?name=finagg_generic_configurations`, requestBody);
      return response;
  }

export async function updateProfile(requestBody: any){
    const response = await ChannelkartNetworkPut(`profiles/finaggintegration_profile`, requestBody);
    return response;
}

export async function getProfileByName(paymentProvideType: string){
    const response = await ChannelkartNetworkGet(`/profiles/name/${paymentProvideType}`);
    return response;
}

export async function getErrorDictionaryApi(paymentProvideType: string){
    const response = await ChannelkartNetworkGet(`/v1/query/getErrorDictionary?paymentProvideType=${paymentProvideType}`);
    return response;
}

export async function getDivision(){
    const response = await ChannelkartNetworkGet(`/v1/divisions`);
    return response;
}